/** @jsx jsx */
import { ThemeProvider, Box, Container, jsx } from 'theme-ui';
import CartProvider from '../../provider/cart-provider';
import theme from '../../gatsby-plugin-theme-ui';
import Header from '../header/header';
import Footer from '../footer/footer';
import CartStatus from '../cart/';
import styles from './layout.style';

const Layout: React.FunctionComponent = ({ children }) => {
	return (
		<ThemeProvider theme={theme}>
			<CartProvider>
				<Box as="main" sx={styles.wrapper}>
					<Header />
					<Container sx={styles.content}>{children}</Container>
					<CartStatus />
					<Footer />
				</Box>
			</CartProvider>
		</ThemeProvider>
	);
};

export default Layout;
